import {useNavigate} from 'react-router-dom';
import {
    FormPageLayout,
    SimplePageContentWrapper,
} from '@flexinet/ui-components';

import {RecordForm} from '../forms/RecordForm';
import {buildInitialValues} from '../forms/buildInitialValues.ts';
import {IndexPageNavigation} from '../navigation/IndexPageNavigation';
import {usePersona} from '../hooks/usePersona.ts';
import {PersonaFormValues} from '../types.ts';
import config from '../config';

export const AddPage = () => {

    const navigate = useNavigate();
    const onCancel = () => {
        navigate(config.basePath);
    };

    const {createRecord} = usePersona();

    const handleSubmit = async (values: PersonaFormValues) => {
        await createRecord(values);
        navigate(config.basePath);
    };

    return (
        <FormPageLayout
            title={`Add ${config.titles.singular}`}
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordForm
                    record={buildInitialValues()}
                    handleSubmit={handleSubmit}
                    handleCancel={onCancel}
                />
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};
